var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"custom-rate"},_vm._l((_vm.max),function(index){return _c('span',{key:index,class:{ active: index <= _vm.currentRating },on:{"click":function($event){return _vm.rate(index)}}},[_vm._t("default",null,{"index":index - 1})],2)}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }